import { useElapsedSeconds } from "@/hooks/use-elapsed-seconds";
import { formatDuration } from "./runFormatting";

/**
 * #1201: a duration cell's words. A known duration reads as itself ("1m 14s", or the caller's
 * `known` text); one still going (`runningSince`, the start of what is running, passed only while
 * it runs) reads "running for 5m 12s", ticking each second, never a bare dash; anything else
 * reads the dash `formatDuration` gives an unknown duration.
 */
export function RunningDuration({
  seconds,
  runningSince,
  known,
}: {
  seconds: number | null | undefined;
  runningSince: string | null | undefined;
  /** The text for a known duration, when the caller words it its own way. */
  known?: string;
}) {
  const isKnown = seconds !== null && seconds !== undefined && Number.isFinite(seconds);
  const elapsed = useElapsedSeconds(isKnown ? null : runningSince);
  if (!isKnown && elapsed !== null) return <>{`running for ${formatDuration(elapsed)}`}</>;
  return <>{known ?? formatDuration(seconds)}</>;
}
